/** Matches common string forms accepted by `System.Guid` in .NET (RFC 4122 canonical). */
const RFC4122 =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;

/** Hex id as returned by GET /api/DataModels (`uuid` / `id`, e.g. 24-char ObjectId-style). */
const CATALOG_UUID_HEX = /^[0-9a-fA-F]{24}$/i;

export function isRFC4122Guid(value: string | null | undefined): boolean {
  if (value == null || typeof value !== "string") return false;
  return RFC4122.test(value.trim());
}

export function isDataModelCatalogUuid(value: string | null | undefined): boolean {
  if (value == null || typeof value !== "string") return false;
  return CATALOG_UUID_HEX.test(value.trim());
}

/** Ids allowed in Resource Access `resourceGuids` (RFC GUID or `/api/DataModels` `uuid`). */
export function isResourceAccessResourceId(value: string | null | undefined): boolean {
  return isRFC4122Guid(value) || isDataModelCatalogUuid(value);
}

export function firstRfc4122Guid(candidates: readonly string[]): string {
  for (let i = 0; i < candidates.length; i += 1) {
    const t = String(candidates[i] ?? "").trim();
    if (RFC4122.test(t)) return t;
  }
  return "";
}

export function firstResourceAccessResourceId(candidates: readonly string[]): string {
  for (let i = 0; i < candidates.length; i += 1) {
    const t = String(candidates[i] ?? "").trim();
    if (isResourceAccessResourceId(t)) return t;
  }
  return "";
}
